// @ts-nocheck

import { createSelector } from 'reselect';

import { __ } from '../../i18n/l10n';
import { selectCatalogValidMissionId } from '../../modules/missions/selectors/banner';
import { getHistoryFromProps } from '../../selectors/_propsGetters_';
import { selectBetFilterId, selectBetFilterIsPending } from '../../selectors/betFilter/betFilterPrimary.selector';
import { selectEntitiesBets } from '../../selectors/entities/bets/entitiesBetsPrimary.selector';
import { selectEntitiesCategoriesEntity } from '../../selectors/entities/categories/entitiesCategoriesPrimary.selector';
import { selectEntitiesSportsEntity } from '../../selectors/entities/sports/entitiesSportsPrimary.selector';
import { selectEntitiesTournamentsEntity } from '../../selectors/entities/tournaments/entitiesTournamentsPrimary.selector';
import { makeLocatedCatalogEntities, selectCatalogEntities } from '../../selectors/route.selector';
import { SeparatorTypes } from '../../types/separator';
import { getPreviousMatchId } from '../../utils/history';

const emptyArray: [] = [];

const getOutrightSeparatorPosition = (matches) => {
  if (!matches?.length) {
    return -1;
  }

  let separatorPosition = matches.length;

  for (let i = matches.length - 1; i >= 0; i--) {
    const match = matches[i];

    // On s'arrete au premier match qui n'est pas un outright
    if (!match.isOutright) {
      break;
    }
    separatorPosition = i;
  }

  // Si le dernier match n'est pas un outright, on ne met pas de séparateur
  if (separatorPosition === matches.length) {
    return -1;
  }

  return separatorPosition;
};

const getRouteFilterMatchIds = createSelector([selectCatalogEntities], (entities) => {
  return entities?.matches ?? emptyArray;
});

const selectCatalogFinalMatches = createSelector(
  [makeLocatedCatalogEntities(), selectBetFilterId, getRouteFilterMatchIds, selectEntitiesBets],
  (matches, betFilterId, betFilterMatchIds, bets) => {
    if (betFilterId !== null && betFilterMatchIds.length > 0) {
      return matches
        .filter((match) => {
          if (match) {
            const { matchId, listBetIds, filters } = match;
            return (
              listBetIds &&
              listBetIds.length > 0 &&
              betFilterMatchIds.indexOf(matchId) !== -1 &&
              filters?.indexOf(betFilterId) !== -1
            );
          }
          return false;
        })
        .map((m) => {
          const { isOutright, mainBetId } = m;
          const betCategoryId = isOutright ? bets[mainBetId]?.betTypeCategoryId : undefined;
          return { ...m, isBetFiltered: true, betCategoryId };
        });
    }
    return matches;
  },
);

const selectMatchesData = createSelector([selectCatalogEntities, selectCatalogFinalMatches], (entities, matches) => {
  return {
    isLoading: entities === undefined || (entities && entities.matches === undefined),
    isNull: entities === null || (entities && entities.matches === null) || false,
    matches,
  };
});

const selectViewData = createSelector([selectMatchesData], ({ matches, isLoading, isNull }) => {
  if (isLoading || isNull) {
    return {
      list: emptyArray,
      isEmpty: matches.length === 0,
      isLoading,
      isNull,
    };
  }

  const separatorPosition = getOutrightSeparatorPosition(matches);

  // Le splice ne devrait pas être fait dans le selecteur car ca provoque un effet de bord.
  // Le splice est effectué 2 fois sur la même référence du tableau matches.
  // Selecteur à revoir, mais en attendant, on check que le séparateur n'est pas présent pour l'ajouter
  if (separatorPosition > 0 && !matches.find((m) => m.separatorType === SeparatorTypes.STANDARD)) {
    matches.splice(separatorPosition, 0, {
      text: __('Bets on the competition'),
      separatorType: SeparatorTypes.STANDARD,
    });
  }

  return {
    list: matches,
    isEmpty: matches.length === 0,
    isLoading,
    isNull,
  };
});

const selectRouteCatalogSelector = createSelector(
  [
    selectEntitiesSportsEntity,
    selectEntitiesCategoriesEntity,
    selectEntitiesTournamentsEntity,
    selectViewData,
    selectBetFilterId,
    selectBetFilterIsPending,
    selectCatalogValidMissionId,
    getHistoryFromProps,
  ],
  (sport, category, tournament, viewData, betFilterId, betFilterIsPending, missionId, history) => {
    return {
      sport,
      category,
      tournament,
      view: viewData,
      anchorMatchId: getPreviousMatchId(history),
      betFilterId,
      isLoading: betFilterIsPending,
      missionId,
    };
  },
);

export default selectRouteCatalogSelector;
